"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VSearchInput_vue_1 = __importDefault(require("../scraps/VSearchInput.vue"));
var CreateUser_vue_1 = __importDefault(require("./CreateUser.vue"));
var permissions_json_1 = __importDefault(require("../../../permissions.json"));
var event_bus_1 = require("../../event-bus");
exports.default = vue_1.default.extend({
    name: "top-menu",
    components: {
        CreateUser: CreateUser_vue_1.default,
        VSearchInput: VSearchInput_vue_1.default
    },
    props: {
        roles: {
            type: Array,
            required: true
        },
        districts: {
            type: Array,
            required: true
        },
        units: {
            type: Array,
            required: true
        }
    },
    data: function () {
        return {
            permissions: permissions_json_1.default,
            search: ""
        };
    },
    methods: {
        onSearchInputEnter: function () {
            event_bus_1.EventBus.$emit(event_bus_1.events.common.search.hit, this.search);
        }
    }
});
